import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

import { store } from './app/store'
import { Provider } from 'react-redux'
import CartMenu from './components/react-public/global/CartMenu';

import { BrowserRouter, Routes, Route } from 'react-router-dom'

import { disableReactDevTools } from '@fvilers/disable-react-devtools';

if ( process.env.NODE_ENV === 'production' ) disableReactDevTools()
console.log("Node Env: ", process.env.NODE_ENV);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<App />} />
        </Routes>
        <CartMenu />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);